import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { createSelector } from "@ngrx/store";
import { encodedValue, Ipractitioner, IPractitionerRole } from "../interfaces/practitioner.interface";
import { IuserState } from "./user.reducer";
import * as immutable from "immutable";
import {IPatient} from "@ispm/user/interfaces/patient.interface";
export const selectUsersFeature = (state: IgenomicsState): IuserState => state.users;
export const selectOrganizationConfigurationData = createSelector(
    selectUsersFeature,
    state => state.organizationConfiguration
);

export const selectCurrentPatient = createSelector(
    selectUsersFeature,
    state => state.currentPatient
)

export const selectCurrentUser = createSelector(
    selectUsersFeature,
    state => state.currentUser
)

export const  selectCurrentUserInfo = createSelector(
    selectCurrentUser,
    currentUser => currentUser?.info as Ipractitioner
)


export const selectCurrentUserPractitionerRoles = createSelector(
    selectCurrentUserInfo,
    info => info?.practitionerRole as IPractitionerRole
)

export const selectPractitioners = (users: IuserState): immutable.Map<string, Ipractitioner> => users.practitioners;
export const selectPractitioner = createSelector(
  selectPractitioners,
  (practitioners, props) => practitioners.get(props.id)
);

export const selectPatients = (users: IuserState): immutable.Map<string, IPatient> => users.patients;
export const selectPatient = createSelector(
  selectPatients,
  (patients, props) => patients.get(props.id)
);

const getUniqueSpecialities = (roles: any[]): any[] => {
  let uniqueSpecialties = [];
  let specialtyCodes = new Set();
  roles?.forEach(role => {
    role.specialty?.forEach(speciality => {
      if(!specialtyCodes.has(speciality.code)){
        specialtyCodes.add(speciality.code);
        uniqueSpecialties.push(speciality);
      }
    })
  })
  return uniqueSpecialties;
};

export const selectCurrentUserSpecialities = createSelector(
    selectCurrentUserPractitionerRoles,
    roles => getUniqueSpecialities(roles)
);

export const selectApplicationsConfiguration = createSelector(selectOrganizationConfigurationData, configuration => configuration?.applications);
